import { httpClient } from '../httpClient';
import { apiErrorHandler } from './helpers';
import { useCustomPaginatedQuery, useCustomQuery } from 'hooks/reactQuery';

export const UNLIMITED_EINVOICE_COUNT = 999999999999;

export const formatEInvoiceQuota = count => {
  if (Number(count) >= UNLIMITED_EINVOICE_COUNT) {
    return 'Unlimited';
  }
  return count != null ? String(count) : '—';
};

export const formatPlanPrice = (amount, currency = 'MYR') => {
  if (amount == null || amount === '') {
    return '—';
  }
  return `${currency.toUpperCase()} ${Number(amount).toFixed(2)}`;
};

export const useGetPaginatedProducts = (query, options = {}) => {
  const fetchPaginatedProducts = async (key, queryToFetch) => {
    return httpClient
      .get('/e-invoice/products/paginated', { params: queryToFetch })
      .then(res => ({
        products: res.data.products || [],
        totalCount: res.data.total || 0
      }))
      .catch(apiErrorHandler);
  };

  return useCustomPaginatedQuery('products', fetchPaginatedProducts, query, options);
};

export const getProduct = id => {
  return httpClient
    .get(`/e-invoice/products/${id}`)
    .then(response => response.data)
    .catch(apiErrorHandler);
};

export const useGetProduct = id => {
  return useCustomQuery('productDetail', [id], () => getProduct(id), {
    shouldFetch: !!id
  });
};

export const createProduct = body => {
  return httpClient
    .post('/e-invoice/products', body)
    .then(response => response.data)
    .catch(apiErrorHandler);
};

export const updateProduct = (id, body) => {
  return httpClient
    .patch(`/e-invoice/products/${id}`, body)
    .then(response => response.data)
    .catch(apiErrorHandler);
};

export const deleteProduct = id => {
  return httpClient
    .delete(`/e-invoice/products/${id}`)
    .then(response => response.data)
    .catch(apiErrorHandler);
};

export const reactivateProduct = id => {
  return httpClient
    .post(`/e-invoice/products/${id}/reactivate`)
    .then(response => response.data)
    .catch(apiErrorHandler);
};
